module.exports = __webpack_public_path__ + "img/40_38_053_280.5e68572d.jpg";